// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurrentDomModal {
  display: flex;
  justify-content: space-between;
}
.CurrentDomModal_container .ant-collapse-content-box {
  height: 10rem;
  overflow: auto;
}
.CurrentDomModal_container .ant-collapse-header {
  text-align: center;
  color: white !important;
  padding: 1rem 2rem !important;
  background: var(--primary-color);
  width: -moz-fit-content;
  width: fit-content;
  margin: auto;
  border-radius: 1rem !important;
}

.graph-card_container .graph-card {
  min-height: 60rem;
}
.BehaviorAnalysisChart_title {
  color: black !important;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/CurrentDomModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".CurrentDomModal {\n  display: flex;\n  justify-content: space-between;\n}\n.CurrentDomModal_container .ant-collapse-content-box {\n  height: 10rem;\n  overflow: auto;\n}\n.CurrentDomModal_container .ant-collapse-header {\n  text-align: center;\n  color: white !important;\n  padding: 1rem 2rem !important;\n  background: var(--primary-color);\n  width: fit-content;\n  margin: auto;\n  border-radius: 1rem !important;\n}\n\n.graph-card_container .graph-card {\n  min-height: 60rem;\n}\n.BehaviorAnalysisChart_title {\n  color: black !important;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
